import {Component, Input} from '@angular/core';
import {CommunityMember} from '../../shared/CommunityMember';
import {CommunityConnectorService} from '../../shared/community-connector.service';

@Component({
  selector: 'em-guest-view',
  templateUrl: './guest-view.component.html',
  styleUrl: './guest-view.component.css'
})
export class GuestViewComponent {

  @Input() guestList: CommunityMember[];


  constructor(private ccs: CommunityConnectorService) {
  }

  getAvatarTemplateUrl(avatarTemplate: string) {
    return this.ccs.getAvatarTemplateUrl(avatarTemplate);
  }
}
